import axios from "axios";

// Local `npm start` uses REACT_APP_API_URL, including http://localhost.
// A production build ignores a non-https URL so visitors never call a developer machine.
const envUrl = String(process.env.REACT_APP_API_URL || "").trim();
const API_BASE_URL =
  process.env.NODE_ENV === "development" && envUrl
    ? envUrl.replace(/\/$/, "")
    : envUrl && /^https:\/\//i.test(envUrl)
      ? envUrl
      : "https://backend.jhonks.com/api";

export function getSocketOrigin() {
  return API_BASE_URL.replace(/\/api\/?$/, "");
}

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = String(error.config?.url || "");
      const isSessionCheck = url.includes("/auth/me");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      const onAuthPage = /^\/(login|register)/.test(window.location.pathname);
      if (!isSessionCheck && !onAuthPage) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
